import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Component({
    selector: "pa-access-denied",
    templateUrl: "./access-denied.component.html",
    styleUrls: ["./access-denied.component.scss"],
    standalone: false
})
export class AccessDeniedComponent implements OnInit {
  launchpadUrl = environment.launchpadUrl;
  contactUrl = environment.contactUrl;

  constructor(private router: Router) {}

  ngOnInit() {}

  navigateToLaunchPad() {
    window.open(this.launchpadUrl);
  }
}
